import * as SolidityFunction from 'web3/lib/web3/function';
import * as Web3 from 'web3';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

const watacoinContractABI = [
  {
    constant: true,
    inputs: [],
    name: 'mintingFinished',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'name',
    outputs: [
      {
        name: '',
        type: 'string'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_spender',
        type: 'address'
      },
      {
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        name: '',
        type: 'uint256'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_from',
        type: 'address'
      },
      {
        name: '_to',
        type: 'address'
      },
      {
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_minter',
        type: 'address'
      }
    ],
    name: 'removeMinter',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        name: '',
        type: 'uint8'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_to',
        type: 'address'
      },
      {
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'mint',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'burn',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_spender',
        type: 'address'
      },
      {
        name: '_subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseApproval',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [
      {
        name: '_owner',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        name: '',
        type: 'uint256'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_from',
        type: 'address'
      },
      {
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'burnFrom',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [],
    name: 'finishMinting',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        name: '',
        type: 'string'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_minter',
        type: 'address'
      }
    ],
    name: 'addMinter',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_to',
        type: 'address'
      },
      {
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'timestamp',
    outputs: [
      {
        name: '',
        type: 'uint256'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_spender',
        type: 'address'
      },
      {
        name: '_addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseApproval',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'whoAmI',
    outputs: [
      {
        name: '',
        type: 'address'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [
      {
        name: '_owner',
        type: 'address'
      },
      {
        name: '_spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        name: '',
        type: 'uint256'
      }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: '',
    payable: false,
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'burner',
        type: 'address'
      },
      {
        indexed: false,
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Burn',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Mint',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [],
    name: 'MintFinished',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        name: '_error',
        type: 'string'
      }
    ],
    name: 'Error',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_assetID',
        type: 'uint256'
      },
      {
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'buyAssetFor',
    outputs: [
      {
        name: '',
        type: 'bool'
      }
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      {
        name: '_contract',
        type: 'address'
      }
    ],
    name: 'setMarketAddress',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  }
];
const marketContractABI = [
  {
    constant: false,
    inputs: [{ name: 'assetId', type: 'uint256' }],
    name: 'buyAsset',
    outputs: [{ name: '', type: 'bool' }],
    payable: true,
    stateMutability: 'payable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'getAssetsIdsForSale',
    outputs: [{ name: '', type: 'uint256[]' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: 'feeIssuer', type: 'uint256' },
      { name: 'feeWatafan', type: 'uint256' },
      { name: 'feeIssuerFirstSale', type: 'uint256' },
      { name: 'feeWatafanFirstSale', type: 'uint256' }
    ],
    name: 'setAssetSaleFees',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: 'assetId', type: 'uint256' },
      { name: 'sellPriceNext', type: 'uint256' }
    ],
    name: 'setAssetPrice',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_assetId', type: 'uint256' }],
    name: 'getAssetStatus',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_assetId', type: 'uint256' }],
    name: 'getAssetPriceLast',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [{ name: 'assetId', type: 'uint256' }],
    name: 'setAssetNotForSale',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_assetId', type: 'uint256' }],
    name: 'getAssetPriceNext',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'timestamp',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_assetId', type: 'uint256' },
      { name: '_user', type: 'address' }
    ],
    name: 'sendGiftAssetTo',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_assetId', type: 'uint256' }],
    name: 'getAssetNumTrades',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'whoAmI',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [{ name: '_address', type: 'address' }],
    name: 'setAssetsContract',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    name: '',
    inputs: [{ name: '_address', type: 'address' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_assetId', type: 'uint256' },
      { indexed: true, name: '_assetBuyer', type: 'address' }
    ],
    name: 'SendGiftAssetTo',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_assetId', type: 'uint256' },
      { indexed: false, name: '_amount', type: 'uint256' }
    ],
    name: 'BuyAsset',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_assetId', type: 'uint256' },
      { indexed: false, name: '_assetOwner', type: 'address' }
    ],
    name: 'SetAssetNotForSale',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_assetId', type: 'uint256' },
      { indexed: false, name: '_assetOwner', type: 'address' },
      { indexed: false, name: '_sellPriceNext', type: 'uint256' }
    ],
    name: 'SetAssetPrice',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, name: '_feeIssuer', type: 'uint256' },
      { indexed: false, name: '_feeWatafan', type: 'uint256' },
      { indexed: false, name: '_feeIssuerFirstSale', type: 'uint256' },
      { indexed: false, name: '_feeWatafanFirstSale', type: 'uint256' }
    ],
    name: 'SetAssetSaleFees',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: '_error', type: 'string' }],
    name: 'Error',
    type: 'event'
  }
];
const appContractABI = [
  {
    constant: true,
    inputs: [{ name: '_interfaceID', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'name',
    outputs: [{ name: '_name', type: 'string' }],
    payable: false,
    stateMutability: 'pure',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_tokenId', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_approved', type: 'address' },
      { name: '_tokenId', type: 'uint256' }
    ],
    name: 'approve',
    outputs: [],
    payable: true,
    stateMutability: 'payable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_from', type: 'address' },
      { name: '_to', type: 'address' },
      { name: '_tokenId', type: 'uint256' }
    ],
    name: 'transferFrom',
    outputs: [],
    payable: true,
    stateMutability: 'payable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [
      { name: '_owner', type: 'address' },
      { name: '_index', type: 'uint256' }
    ],
    name: 'tokenOfOwnerByIndex',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_issuer', type: 'address' }],
    name: 'getAssetsIdsIssuedBy',
    outputs: [{ name: '', type: 'uint256[]' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_from', type: 'address' },
      { name: '_to', type: 'address' },
      { name: '_tokenId', type: 'uint256' }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    payable: true,
    stateMutability: 'payable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: 'assetId', type: 'uint256' }],
    name: 'getAssetOwnerIssuer',
    outputs: [{ name: '', type: 'address' }, { name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_index', type: 'uint256' }],
    name: 'tokenByIndex',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: 'S', type: 'string' }, { name: 'N', type: 'uint256' }],
    name: 'myHash',
    outputs: [{ name: '', type: 'bytes32' }],
    payable: false,
    stateMutability: 'pure',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_tokenId', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: 'printHash', type: 'bytes32' }],
    name: 'getAssetIdByHash',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [{ name: '_operator', type: 'address' }],
    name: 'setApprovedOperator',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: false,
    inputs: [{ name: '_branding', type: 'string' }],
    name: 'setAssetBranding',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: 'assetId', type: 'uint256' }],
    name: 'getAssetById2',
    outputs: [
      { name: '_branding', type: 'string' },
      { name: '_printTitle', type: 'string' },
      { name: '_printNumber', type: 'uint256' },
      { name: '_printMax', type: 'uint256' },
      { name: '_printHash', type: 'bytes32' },
      { name: '_numTrades', type: 'uint256' },
      { name: '_sellPriceNext', type: 'uint256' }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '_symbol', type: 'string' }],
    payable: false,
    stateMutability: 'pure',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_operator', type: 'address' },
      { name: '_approved', type: 'bool' }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_assetOwner', type: 'address' }],
    name: 'getAssetsIdsOwnedBy',
    outputs: [{ name: '', type: 'uint256[]' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol_',
    outputs: [{ name: '', type: 'string' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: 'assetId', type: 'uint256' }],
    name: 'getAssetById',
    outputs: [
      { name: '_assetId', type: 'uint256' },
      { name: '_assetOwner', type: 'address' },
      { name: '_issuer', type: 'address' },
      { name: '_content', type: 'string' },
      { name: '_sellPriceLast', type: 'uint256' },
      { name: '_status', type: 'uint256' },
      { name: '_idolName', type: 'bytes32' }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'timestamp',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_from', type: 'address' },
      { name: '_to', type: 'address' },
      { name: '_tokenId', type: 'uint256' },
      { name: '_data', type: 'bytes' }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    payable: true,
    stateMutability: 'payable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_tokenId', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', type: 'string' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'whoAmI',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'name_',
    outputs: [{ name: '', type: 'string' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [
      { name: '_owner', type: 'address' },
      { name: '_operator', type: 'address' }
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'SCIssuers',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: 'content', type: 'string' },
      { name: 'to', type: 'address' },
      { name: '_printTitle', type: 'string' },
      { name: '_printNumber', type: 'uint256' },
      { name: '_printMax', type: 'uint256' }
    ],
    name: 'issueAssetTo',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ name: '_SCIssuers', type: 'address' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'constructor',
    name: ''
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_assetId', type: 'uint256' },
      { indexed: false, name: '_idolName', type: 'bytes32' },
      { indexed: true, name: '_assetOwner', type: 'address' },
      { indexed: false, name: '_printTitle', type: 'string' },
      { indexed: false, name: '_printNumber', type: 'uint256' },
      { indexed: false, name: '_printMax', type: 'uint256' },
      { indexed: false, name: '_printHash', type: 'bytes32' }
    ],
    name: 'IssueAsset',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: '_branding', type: 'string' }],
    name: 'SetAssetBranding',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_from', type: 'address' },
      { indexed: true, name: '_to', type: 'address' },
      { indexed: false, name: '_tokenId', type: 'uint256' }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_owner', type: 'address' },
      { indexed: true, name: '_approved', type: 'address' },
      { indexed: false, name: '_tokenId', type: 'uint256' }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: '_owner', type: 'address' },
      { indexed: true, name: '_operator', type: 'address' },
      { indexed: false, name: '_approved', type: 'bool' }
    ],
    name: 'ApprovalForAll',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: '_error', type: 'string' }],
    name: 'Error',
    type: 'event'
  }
];
const issuerContractABI = [
  {
    constant: false,
    inputs: [{ name: '_issuer', type: 'address' }],
    name: 'revokeIssuer',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_issuer', type: 'address' }],
    name: 'getIdolNameByAddress',
    outputs: [{ name: '_idolName', type: 'bytes32' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_issuer', type: 'address' }],
    name: 'getIssuerByAddress',
    outputs: [
      { name: '_issuerId', type: 'uint256' },
      { name: '_issuerAuth', type: 'bool' },
      { name: '_issuerAddress', type: 'address' },
      { name: '_issuerContent', type: 'string' },
      { name: '_idolName', type: 'bytes32' }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_issuer', type: 'address' }],
    name: 'isIssuer',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: 'id', type: 'uint256' }],
    name: 'getIssuerById',
    outputs: [
      { name: '_issuerId', type: 'uint256' },
      { name: '_issuerAuth', type: 'bool' },
      { name: '_issuerAddress', type: 'address' },
      { name: '_issuerContent', type: 'string' },
      { name: '_idolName', type: 'bytes32' }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'timestamp',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'whoAmI',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_issuer', type: 'address' },
      { name: '_content', type: 'string' },
      { name: '_idolName', type: 'bytes32' }
    ],
    name: 'grantIssuer',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'who', type: 'address' },
      { indexed: true, name: '_id', type: 'uint256' },
      { indexed: false, name: '_idolName', type: 'bytes32' },
      { indexed: false, name: '_timestamp', type: 'uint256' }
    ],
    name: 'NewIssuer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'who', type: 'address' },
      { indexed: true, name: '_id', type: 'uint256' },
      { indexed: false, name: '_idolName', type: 'bytes32' },
      { indexed: false, name: '_timestamp', type: 'uint256' }
    ],
    name: 'GrantIssuer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'who', type: 'address' },
      { indexed: false, name: '_timestamp', type: 'uint256' }
    ],
    name: 'RevokeIssuer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: '_error', type: 'string' }],
    name: 'Error',
    type: 'event'
  }
];

@Injectable()
export class ContractsService {
  public web3 = new Web3();
  issuerContractAddr: string;
  appContractAddr: string;
  marketContractAddr: string;
  watacoinContractAddr: string;

  WatacoinContract: any = {};
  MarketContract: any = {};
  AppContract: any = {};
  IssuerContract: any = {};
  constructor() {
    //this.fetchSCAddresses();
  }

  async fetchSCAddresses() {
    await firebase
      .database()
      .ref('/prod_SC')
      .once('value')
      .then(snapshot => {
        if (snapshot.val()) {
          var sc = snapshot.val();
          console.log('SC Values', sc);
          this.appContractAddr = sc.assetsContractAddr;
          this.issuerContractAddr = sc.issuerContractAddr;
          this.marketContractAddr = sc.marketContractAddr;
          this.watacoinContractAddr = sc.watacoinContractAddr;

          this.setIssuerContracts();
          this.setAssetsContracts();
          this.setMarketContract();
          this.setWatacoinsContract();
          console.log('saliendo del FetchSCAddresses');
        }
      });
  }

  setIssuerContracts() {
    this.IssuerContract = {
      address: this.issuerContractAddr,
      getIdolNameByAddress: (address: string): any => {},
      getIssuerByAddress: (address: string): any => {},
      getIssuerById: function(assetId: number) {},
      isIssuer: (address: string): any => {}
    };

    for (var i = 0; i < issuerContractABI.length; i++) {
      if (!issuerContractABI[i].hasOwnProperty('outputs'))
        issuerContractABI[i]['outputs'] = [];
      if (issuerContractABI[i].type === 'function') {
        this.IssuerContract[issuerContractABI[i].name] = new SolidityFunction(
          this.web3.eth,
          issuerContractABI[i],
          this.issuerContractAddr
        );
      }
    }
  }

  setAssetsContracts() {
    this.AppContract = {
      address: this.appContractAddr,
      getAssetsIdsIssuedBy: (address: string): any => {},
      getAssetsIdsOwnedBy: (address: string): any => {},
      getAssetById: (assetId: number) => {},
      getAssetById2: (assetId: number) => {},
      issueAssetTo: {
        toPayload: (data: any[]): any => {}
      },
      web3: this.web3
    };

    for (var i = 0; i < appContractABI.length; i++) {
      if (!appContractABI[i].hasOwnProperty('outputs'))
        appContractABI[i]['outputs'] = [];
      if (appContractABI[i].type === 'function') {
        this.AppContract[appContractABI[i].name] = new SolidityFunction(
          this.web3.eth,
          appContractABI[i],
          this.appContractAddr
        );
      }
    }
  }

  setMarketContract() {
    this.MarketContract = {
      address: this.marketContractAddr,
      getAssetsIdsForSale: function(): any {},
      setAssetPrice: {
        toPayload: (data: any[]): any => {}
      },
      setAssetNotForSale: {
        toPayload: (data: any[]): any => {}
      },
      buyAsset: {
        toPayload: (data: any[]): any => {}
      }
    };

    for (var i = 0; i < marketContractABI.length; i++) {
      if (!marketContractABI[i].hasOwnProperty('outputs'))
        marketContractABI[i]['outputs'] = [];
      if (marketContractABI[i].type === 'function') {
        this.MarketContract[marketContractABI[i].name] = new SolidityFunction(
          this.web3.eth,
          marketContractABI[i],
          this.marketContractAddr
        );
      }
    }
  }

  setWatacoinsContract() {
    this.WatacoinContract = {
      address: this.watacoinContractAddr,
      balanceOf: (address: string): any => {},
      transfer: {
        toPayload: (data: any[]): any => {}
      },
      buyAssetFor: {
        toPayload: (data: any[]): any => {}
      }
    };

    for (var i = 0; i < watacoinContractABI.length; i++) {
      if (!watacoinContractABI[i].hasOwnProperty('outputs'))
        watacoinContractABI[i]['outputs'] = [];
      if (watacoinContractABI[i].type === 'function') {
        this.WatacoinContract[
          watacoinContractABI[i].name
        ] = new SolidityFunction(
          this.web3.eth,
          watacoinContractABI[i],
          this.watacoinContractAddr
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.contract.service.ts